/**
 * 
 */
 class WMUHideAndSeek {

	/**
	 * 
	 */
	constructor( selector )
	{
		this.elementList = null;
		this.initScrollY = window.scrollY;
		this.lastScrollY = 0;
		this.selector = selector;

		window.addEventListener( 'scroll', this.onWindowScroll.bind( this ) );

		if ( this.initScrollY > 0 )
		{
			this.hide();
		}
	}

	/**
	 * 
	 */
	getElementList()
	{
		if ( null === this.elementList )
		{
			this.elementList = document.querySelectorAll( this.selector );
		}

		return this.elementList;
	}

	/**
	 * 
	 */
	hide()
	{
		const elementList = this.getElementList();

		if ( elementList && elementList.length )
		{
			elementList.forEach( ( element ) =>
			{
				element.classList.add( 'wmu-hs-hide' );
				element.classList.remove( 'wmu-hs-seek' );
			} );
		}
	}

	/**
	 * 
	 */
	seek()
	{
		const elementList = this.getElementList();

		if ( elementList && elementList.length )
		{
			elementList.forEach( ( element ) =>
			{
				element.classList.remove( 'wmu-hs-hide' );
				element.classList.add( 'wmu-hs-seek' );
			} );
		}
	}

	/**
	 * 
	 */
	onWindowScroll( event )
	{
		// if ( window.scrollY > this.lastScrollY && window.scrollY > 3 )
		if ( window.scrollY > this.lastScrollY )
		{
			this.hide();
		}
		else if ( window.scrollY < this.lastScrollY )
		{
			this.seek();
		}

		// Save last scrollY and limit it between 0 and document's height minus window's height to prevent bad behavior on bounced scroll
		this.lastScrollY = Math.max( 0, Math.min( window.scrollY, document.body.clientHeight - window.innerHeight ) );
	}

}

export default WMUHideAndSeek;